class TasacionesPreloadAssets {
    static preloadSpinner(url) {
        if (!url) return;

        // Forzar descarga creando un <video> offscreen
        try {
            const video = document.createElement('video');
            video.preload = 'auto';
            video.muted = true;
            video.playsInline = true;
            video.src = url;

            // Para maximizar compatibilidad (iOS/Safari), lo añadimos offscreen y lo retiramos al cargar
            const holder = document.createElement('div');
            holder.style.position = 'absolute';
            holder.style.left = '-9999px';
            holder.style.width = '1px';
            holder.style.height = '1px';
            holder.style.overflow = 'hidden';
            holder.appendChild(video);
            document.addEventListener('DOMContentLoaded', () => {
                document.body.appendChild(holder);
                try { video.load(); } catch (_) {}
            });

            const cleanup = () => {
                try { holder.remove(); } catch (_) {}
            };
            video.addEventListener('loadeddata', cleanup, { once: true });
            video.addEventListener('error', cleanup, { once: true });
        } catch (_) {}
    }
}

// Auto-ejecución si hay config disponible
(function () {
    const url = (typeof TasacionesConf !== 'undefined' && TasacionesConf.spinner_url) ? TasacionesConf.spinner_url : null;
    if (url) {
        TasacionesPreloadAssets.preloadSpinner(url);
    }
    // Exponer por si necesitas llamarlo manualmente
    window.TasacionesPreloadAssets = TasacionesPreloadAssets;
})();